export default {
  computed: {
    users () {
      return this.$store.getters['UsersStore/users']
    },
    lastPage () {
      return this.$store.getters['UsersStore/lastPage']
    },
    currentPage () {
      return this.$store.getters['UsersStore/currentPage']
    },
    isCallingUsers () {
      return this.$store.getters['UsersStore/isCallingUsers']
    }
  },
  methods: {
    nextPage () {
      this.$store.dispatch('UsersStore/nextUsersPage')
    }
  }

}
